export default __webpack_public_path__ + "static/media/ic_cancel.28ceb230.svg";